import { useEffect, useRef, useState, useCallback } from 'react';

export function useInView(threshold = 0.15) {
  const ref = useRef<HTMLDivElement>(null);
  const [isInView, setIsInView] = useState(false);

  const callback = useCallback((entries: IntersectionObserverEntry[]) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        setIsInView(true);
      }
    });
  }, []);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;

    const observer = new IntersectionObserver(callback, {
      threshold,
      rootMargin: '0px 0px -40px 0px',
    });

    observer.observe(node);
    return () => observer.disconnect();
  }, [callback, threshold]);

  return { ref, isInView };
}